import RatingPage from '@components/RatingPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const RATING_TO_ANSWER = {
  '1': 'Rarely',
  '2': 'Occasionally',
  '3': 'Sometimes',
  '4': 'Often',
  '5': 'Daily',
}

export default function SleepTroublePage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(RATING_TO_ANSWER).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('rating') as string

    if (!answerValue) return

    const answer = {
      question_key: 'sleep_trouble',
      question: 'How frequently do you have trouble falling asleep?',
      answer_key: answerValue,
      answer: RATING_TO_ANSWER[answerValue as keyof typeof RATING_TO_ANSWER],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer('sleep_trouble', answer)
    }
  }

  return (
    <RatingPage
      title="pages.onboarding.sleepTrouble.heading"
      minSubtitle="pages.onboarding.sleepTrouble.options.rarely"
      maxSubtitle="pages.onboarding.sleepTrouble.options.daily"
      preselectedValue={preselectedValue}
      onSubmit={handleSubmit}
    />
  )
}
